import React from 'react'
import { RouteProps } from '../../routes/AppRouter'
import { Statistics as ST } from '../../features/statistics'
import { useTitleHeaderContext } from '../../common/utils/TitleHeaderContext'
import logoCareme from '../../assets/caremePlusLogo.svg'
import style from '../layout/Main.module.css'
import { Box } from '@mui/material'
import { useParams } from 'react-router-dom'

export function Statistics(props: RouteProps) {
  const title = props.title || ''
  const { setTitle } = useTitleHeaderContext()
  const { id } = useParams()

  setTitle(title)

  return (
    <>
      <ST id={id || ''} />
      <Box display={'flex'} justifyContent={'flex-end'}>
        <img src={logoCareme} alt="Logo Careme" className={style.logo} />
      </Box>
    </>
  )
}
